<template>
    <div>
        <div class="flex-row d-flex flex-wrap align-items-center">
            <div :class="{ 'col-lg-8 mb-4': !options.graphView, 'col-12 mb-2': options.graphView }">
                <div class="row">
                    <h1 class="float-left" v-if="!node.id">{{ $t("add-node") }}</h1>
                    <h1 class="float-left" v-else-if="node.title">
                        {{ node.title }}
                    </h1>
                    <div class="skeleton midnight h32 w-half" v-else></div>
                </div>
                <div class="flex-row d-flex justify-content-end" v-if="options.nodeLinks">
                    <h3>
                        <button class="btn btn-outline-primary" 
                            @click="$router.push(`/curriculum-mapping/node/${node.id}/detail`)"
                        >
                            <b-icon icon="info-circle-fill" width="1em" height="1em" class="ml-2" /> {{ $t('detail')}}
                        </button>
                        <button class="btn btn-outline-primary ml-1" 
                            @click="$router.push(`/curriculum-mapping/node/${node.id}/graph`)"
                        >
                            <b-icon icon="zoom-in" width="1em" height="1em" class="ml-2" /> {{ $t('zoom')}}
                        </button>
                    </h3>
                </div>
                <div 
                    v-if="editing && options.spareChildrenNodes && node.children && node.children.length > 0 && $UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
                    class="row d-flex justify-content-end">
                    <CheckboxInput v-if="node.children.length > 0 && node.parent_id !== null" :value="spare_children"
                        @input="spare_children = !spare_children" :label="$t('spare-children')" />
                    <small v-if="spare_children" class="text-muted">{{ $t('spare-children-text') }}</small>
                </div>
            </div>
            <div class="d-flex justify-content-end" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
                :class="{ 'col-lg-4 mb-4': !options.graphView, 'col-12 mb-2': options.graphView }">
                <button v-if="editing" class="btn btn-primary float-right ml-4 mb-2"
                    @click="saveNode(node, node.absolute_parent_id, node.root_id)" :disabled="!node.title">
                    {{ $t("save") }}
                </button>
                <button class="btn btn-primary float-right ml-1 mb-2" @click="editing = true" v-else>
                    {{ $t("edit") }}
                </button>
                <button v-if="editing && node.id" class="btn btn-danger float-right ml-1  mb-2"
                    @click="deleteNode(node)">
                    {{ $t("delete") }}
                </button>
                <button v-if="editing && node.id" class="btn btn-secondary float-right ml-1 mb-2"
                    @click="editing = false">
                    {{ $t("cancel") }}
                </button>
            </div>
        </div>
        <!--div class="row" v-if="error">
            <div class="col-12">
                <b-alert variant="danger" show>{{ error }}</b-alert>
            </div>
        </div-->
        <div class="row" v-if="options.breadcrumbs">
            <div class="col-12">
                <b-breadcrumb>
                    <b-breadcrumb-item v-for="node in path" :key="node.id"
                        :active="node.parent_id == null && node.absolute_parent_id !== null"
                        :href="`/curriculum-mapping/node/${node.id}/detail`">
                            {{ node.title }}
                    </b-breadcrumb-item>
                </b-breadcrumb>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-sm-12 col-lg-6 mb-2">
                <TextInput :label="$t('title')" v-model="node.title" v-if="editing" />
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("title") }}</label>
                    <p class="mb-0">
                        {{ node.title !== null ? node.title : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
            <div class="col-sm-12 col-lg-6 mb-2">
                <SelectInput v-if="editing" v-model="node.curriculumcomponenttype_id" :options="components"
                    optionLabel="title" optionValue="id" :label="$t('component')" class="font-bold">
                </SelectInput>
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("component") }}</label>
                    <p class="mb-2">
                        {{ component !== null ? component.title : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-12">
                <TextAreaInput v-if="editing" v-model="node.note" :label="$t('notes')" class="font-bold" />
                <template v-else-if="node.title">
                    <label class="font-bold">{{ $t("notes") }}</label>
                    <p class="mb-0">
                        {{ node.note ? node.note : $t('none') }}
                    </p>
                </template>
                <div class="skeleton midnight h16 w-half" v-else></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <Table v-if="node.children && node.children.length > 0 && options.displayChildren"
                    :loading="!node.children" 
                    :submitting="submitting" 
                    :cols="tableCols" 
                    :data="node.children"
                    breakpoint="md" 
                    :filters="{
                        ...filters,
                        page: filters.page,
                        page_size: filters.page_size,
                    }" 
                    :searchable="false" 
                    :scrollPaginate="true" 
                    @refresh="refresh"
                    @selectItem="children_node => $router.push(`/curriculum-mapping/node/${children_node.id}/detail`)"
                    :allowRightClick="true"
                    @deleteItem="children_node => deleteNode(children_node)"
                >
                    <template v-slot:header>
                        <h2>{{ $t('nodes') }}</h2>
                    </template>
                </Table>
            </div>
        </div>
        <div class="col-12" style="padding-right:0px;">
            <div class="d-flex justify-content-end" v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')">
                <button v-if="options.newNodeEditor"
                        class="btn ml-auto"
                        :class="addingNewNode ? 'btn-secondary' : 'btn-primary'" 
                        @click="addingNewNode = !addingNewNode"
                    >
                    <b-icon v-if="!addingNewNode" icon="plus" class="h6 mb-0 mr-1"/>{{ addingNewNode ? $t('done') : $t('add-node') }}
                </button>
            </div>
            <!-- START Add New Node-->
            <div class="row">
                <div class="col-12">
                    <div class="card mb-2 mt-2" v-if="addingNewNode">
                        <h5 class="card-header">{{ $t('add-new-children-node') }}</h5>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <TextInput v-model="newNode.title" :label="$t('title')" class="font-bold" />
                                </div>
                                <div class="col-12">
                                    <SelectInput v-model="newNode.curriculumcomponenttype_id" :options="components"
                                        optionLabel="title" optionValue="id" :label="$t('component')" class="font-bold" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <TextAreaInput v-model="newNode.note" :label="$t('notes')" class="font-bold" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button class="btn btn-outline-primary float-right"
                                        @click="saveNode(newNode, node.id, node.root_id)">
                                        {{ $t('add-node') }}
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="font-bold">{{ $t('learning-outcomes') }}</h3>
                                    <LearningOutcomesMapper v-model="newNode.learningoutcomes" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END Add New Node-->
        </div>
                
        <LearningOutcomesMapper v-if="options.learningOutcomes" 
            v-model="node.learningoutcomes.joint"
            @doneEditing="saveLearningOutcomes"
            :viewOnly="!$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
        >
            <template v-slot:label>
                <h2>{{ $t('learning-outcomes') }}</h2>
            </template>
        </LearningOutcomesMapper>
            
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import CheckboxInput from "src/components/Inputs/CheckboxInput.vue"

export default {
    props: {
        options: Object,
        node: Object,
        viewOnly: Boolean
    },
    components: {
        Table,
        LearningOutcomesMapper,
        CheckboxInput,
    },
    data: function () {
        return {
            error: null,
            //loaded: false,
            editing: false,
            nodes: [],
            spare_children: false,
            newNode: {},
            submitting: false,
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                search: '',
            },
            components: [],
            learningoutcomes: [],
            path: [],
            dendoWrapperStyle: "position: fixed; top: 0px; bottom:0; left: 0; right:10px; overflow: hidden;",
            addingNewNode: false
        };
    },
    mounted() {
        this.getComponents();
        this.getOutcomes()
        if (this.options.breadcrumbs) this.getPath();
    },
    methods: {
        /**
        * Saves a node. If there are parent_id and/or root_id, it is saved as a children of the that parent node with that root.
        *
        * @param {Object} node - The node chosen from the hierarchy.
        * @param {string} parent_id - The id of the parent node.
        * @param {string} root_id - The id of the root node.
        */
        saveNode(node, parent_id = null, root_id = null) {
            //this.saving = true;
            if (!node) {
                throw new Error('Not a valid node');
            }

            let newChild = false;

            if (!node.absolute_parent_id) newChild = true; // If the node has no parent, then it is a new child

            if (parent_id) node.parent_id = parent_id
            if (root_id) node.root_id = root_id;

            if (node.learningoutcomes?.original) {
                const original_ids = node.learningoutcomes.original;

                // Remember that joint is an array of objects while original and linked are arrays of ids.
                const lo_tosave = original_ids && original_ids.length > 0
                    ? node.learningoutcomes.joint.filter(obj => node.learningoutcomes.original.includes(obj.id))
                    : node.learningoutcomes.joint;

                node.learningoutcomes = lo_tosave;
            }

            return this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/save`, {
                method: "post",
                data: node
            })
            .then((res) => {

                if (res.status === 'SUCCESS') {
                    let apiNode = res.result;
                    /** 
                    * This fixes the learning outcomes for the mapper, as it 
                    * only accepts Arrays of objects
                    */
                    if (apiNode.learningoutcomes) {
                        const node_learningoutcomes = apiNode.learningoutcomes;

                        apiNode.learningoutcomes = {};

                        apiNode.learningoutcomes.linked = node.learningoutcomes?.linked ? node.learningoutcomes.linked : [];
                        apiNode.learningoutcomes.original = node_learningoutcomes.map(item => item.id);


                        const joint_ids = [
                            ...apiNode.learningoutcomes.original,
                            ...apiNode.learningoutcomes.linked
                        ]

                        apiNode.learningoutcomes.joint = this.learningoutcomes.filter(obj => joint_ids.includes(obj.id))
                    }

                    let selectedNode = {};
                    if (newChild) {
                        selectedNode = this.node;
                        selectedNode.children.push(apiNode);
                    } else {
                        selectedNode = apiNode;
                    }

                    this.$emit('nodeChanges', {
                        action: newChild ? 'node_added' : 'node_saved',
                        data: selectedNode
                    })

                } else {
                    this.$log.error.call(this, "Could not save node");
                }
            })
            .catch(error => {
                console.log('Error while saving node: ', error);
                this.$log.error.call(this, error);
            }).finally(() => {
                if (newChild){ 
                    this.newNode = {}
                } else {
                    this.editing = false;
                }
            });
        },

        deleteNode(node) {
            if (!node.parent_id) { // Selected node is the root, cannot be deleted
                this.$store.commit("openDialog", {
                    title: this.$t("oops"),
                    content: this.$t("you-can-not-delete-the-root")
                });

                return;
            }

            const data_to_delete = {
                id: node.id,
                spare_children: this.spare_children,
                parent_id: node.parent_id
            }

            return this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/delete`, {
                method: "post",
                data: data_to_delete
            })
                .then((res) => {
                    if (res.status === 'SUCCESS') {
                        this.$emit('nodeChanges', {
                            action: 'node_deleted',
                            data: data_to_delete
                        })
                    }
                }).catch(error => {
                    this.$log.error.call(this, error);
                }).finally(() => {
                    this.newNode = {};
                    this.editing = false;
                })
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters }
        },
        getComponents() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/component/list`, {
                method: 'post'
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.components = res.results;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        },
        getOutcomes() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`, {
                method: 'POST',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching learning outcomes')
                this.learningoutcomes = res.results
                return res.results;
            }).catch(err => {
                console.error(err);
                this.$log.error.call(this, err);
            })
        },
        getComponentTitle(id) {
            if (this.components.filter(obj => id == obj.id).length > 0) {
                return this.components.filter(obj => id == obj.id)[0].title;
            }
            return null;
        },
        getPath() {
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listnodes`, {
                method: 'post',
                data: {
                    id: this.$route.params.id
                }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    if (res.results) this.path = res.results.filter(item => item.id == this.$route.params.id)[0].path;
                }
            }).catch(err => {
                console.error(err);
                this.$log.error.call(this, err);
            });
        },
        saveLearningOutcomes(doneEditing) {
            if(doneEditing){
                let node = {};
                let learningoutcomes = [];
                // We make sure that we only save original outcomes, not linked
                if (this.node.learningoutcomes.linked?.length > 0) {
                    const linked_ids = this.node.learningoutcomes.linked;
                    learningoutcomes = this.node.learningoutcomes.joint.filter(obj => !linked_ids.includes(obj.id)); // Filter out linked nodes
                } else {
                    learningoutcomes = this.node.learningoutcomes.joint
                }

                node = {
                    ...this.node,
                    learningoutcomes: learningoutcomes
                }

                this.saveNode(node,node.absolute_parent_id,node.root_id)
            }
        },
    },
    computed: {
        component() {
            if (this.components && this.node.curriculumcomponenttype_id) {
                return this.components.filter(obj => this.node.curriculumcomponenttype_id == obj.id);
            }
            return null;
        },
        tableCols() {
            let cols = [
                { key: 'title', heading: this.$t('name'), size: this.options.graphView ? 6 : 4 },
                {
                    key: 'curriculumcomponenttype_id', heading: this.$t('component'), size: this.options.graphView ? 6 : 4,
                    cb: (node) => this.getComponentTitle(node.curriculumcomponenttype_id)
                },
            ]

            if (!this.options.graphView) cols.push({ key: 'note', heading: this.$t('notes'), size: 4 });

            return cols;
        }
    },
};
</script>
